import React from "react";
import BuilderHeader from "./BuilderHeader";
import BuilderSidebar from "./BuilderSidebar";
import BuilderWorkspace from "./BuilderWorkspace";

export default class Builder extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="Builder">
        <BuilderHeader {...this.props} />
        <BuilderSidebar>{this.props.sidebar}</BuilderSidebar>
        <BuilderWorkspace>{this.props.workspace}</BuilderWorkspace>
      </div>
    );
  }
}
